<cmps-wait-status *ngIf="hasPendingData"></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<ng-container *ngIf="!hasPendingData && data != null">
    <p>
        {{
            i18n._712_EXPECTED_OPPORTUNITIES_FOR_THE_MONTH___VALUE_
                | translate: { value: data.expectedOps }
        }}
    </p>
    <div class="table-responsive">
        <table class="table table-striped table-sm table-bordered-no-cells">
            <thead class="thead-light">
                <tr>
                    <th aria-hidden="true"></th>
                    <th>{{ i18n._713_METRIC | translate }}</th>
                    <th>{{ i18n._714__30_DAY | translate }}</th>
                    <th>{{ i18n._715_WTD | translate }}</th>
                    <th>{{ i18n._716_COMBINED | translate }}</th>
                    <th>{{ i18n._75_START_DATE | translate }}</th>
                    <th>{{ i18n._717_SCORECARD_WEIGHT | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let i of data.items">
                    <td
                        class="text-center"
                        aria-hidden="true"
                    >
                        <cmps-icon
                            class="cmps-cdk-fill-red-100"
                            svgIcon="exclamation-thick"
                        ></cmps-icon>
                    </td>
                    <td>{{ i.metricName }}</td>
                    <td>{{ i.variance_30Days | percent: '1.2-2' }}</td>
                    <td>{{ i.variance_Wtd | percent: '1.2-2' }}</td>
                    <td>{{ i.combinedVariance | percent: '1.2-2' }}</td>
                    <td>{{ i.startedOn | date: 'y-MM-dd' }}</td>
                    <td>{{ i.scorecardWeight | percent: '1.2-2' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="w-100 text-right">
        {{
            i18n._718___NOTE__COMBINED___IS_70__30_DAY_VARIANCE_AND_30__WTD_VARIANCE
                | translate
        }}
    </div>
</ng-container>
